<!-- Projects Widget -->
<div class="rounded-[24px] bg-white p-[36px] flex flex-col gap-[20px] items-start min-w-0 h-full overflow-clip shadow-[0px_4px_20px_0px_rgba(20,31,71,0.08)]">
    <!-- Header -->
    <div class="flex items-center shrink-0 w-full">
        <div class="flex items-center gap-[8px]">
            <span class="projects-title widget-title text-black" style="font-feature-settings: 'ss01' on, 'cv01' on">Projects</span>
            <i class="pi pi-info-circle text-[16px] w-4 h-4 text-[#787B83]"
                pTooltip="Total count of projects categorized by status"
                tooltipPosition="top"></i>
        </div>
    </div>

    <!-- Chart -->
    <div echarts [options]="chartOptions()" (chartClick)="onChartClick($event)"
         class="w-full h-[220px] shrink-0 overflow-hidden"></div>
</div>
